import {
  Box,
  Grid,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as AirlineTicket } from "assets/icons/Airline_Ticket.svg";
import { ReactComponent as Hotel } from "assets/icons/Hotel.svg";
import { ReactComponent as Share } from "assets/icons/Share.svg";
import { ReactComponent as IconCard } from "assets/icons/icon_card.svg";
import { ReactComponent as IconGreenTick } from "assets/icons/icon_green_tick.svg";
import { ReactComponent as IconVipCard } from "assets/icons/icon_vip_card.svg";
import { GREY_700, GREY_900, WHITE } from "assets/theme/colors";
import { Col, Row, snackbarSetting } from "modules/common/Elements";
import moment from "moment";
import { useSnackbar } from "notistack";
import { Image, Table } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import { FormattedMessage } from "react-intl";
import {
  LOGO_MYTOUR,
  NO_PROFILE_IMG,
  some,
} from "../../../../constants/constants";

interface Booking {
  bookingTime: string;
  isFlight?: boolean;
  description: string;
}

export function sortByBookingTime(bookings: Booking[]): Booking[] {
  const sortedBookings = bookings.sort((a, b) => {
    const timeA = moment(a.bookingTime, "DD-MM-YYYY hh:mm:ss").toDate();
    const timeB = moment(b.bookingTime, "DD-MM-YYYY hh:mm:ss").toDate();
    return timeB.getTime() - timeA.getTime();
  });

  return sortedBookings.slice(0, 10);
}

const useStyles = makeStyles({
  root: {
    marginTop: 16,
    height: "100%",
    width: "100%",
    maxWidth: "860px",
    overflow: "hidden",
    borderRadius: 4,
    // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    color: GREY_900,
  },
  bookerTitle: {
    color: GREY_700,
    marginBottom: 4,
  },
  displayInfo: {
    marginBottom: 4,
  },
  cardTitle: {
    fontSize: 14,
    color: "#8B672B",
  },
  cardContent: {
    fontSize: 14,
    color: "#46300C",
    fontWeight: 500,
  },
  card: {
    padding: "16px 20px",
    backgroundColor: WHITE,
    borderRadius: 6,
    border: "0.5px solid #B2B8B9",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: 14,
    width: "80vw",
  },
  table: {},
});

interface Props {
  getRankingIcon: () => void;
  info: some;
  sumBookings: number;
  vipInfo?: some;
}

const BookerInfoBoxMobile: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { info, vipInfo } = props;

  return (
    <div className={classes.root} style={{ maxWidth: "91vw" }}>
      <Col style={{}}>
        <Typography variant="h5">
          <FormattedMessage id="booker.info" />
        </Typography>
        <CopyToClipboard
          text={`https://tracuu.tripipartner.vn/bookerInfo?phone=${info?.phone}`}
          onCopy={(textValue: string, v: boolean) => {
            if (textValue && v) {
              enqueueSnackbar(
                "Đã lưu thành công",
                snackbarSetting((key) => closeSnackbar(key), {
                  color: "success",
                })
              );
            }
          }}
        >
          <Typography
            variant="body2"
            style={{
              color: "#4794FF",
              display: "flex",
              cursor: "pointer",
            }}
          >
            <Share />
            &nbsp; Chia sẻ link tới khách hàng
          </Typography>
        </CopyToClipboard>
      </Col>
      <Grid container direction="column">
        <Grid item xs={6}>
          <Box position="absolute">
            {vipInfo?.packages?.[0]?.vipPackage?.active ? (
              <IconVipCard style={{ width: "91vw", height: 211 }} />
            ) : (
              <IconCard style={{ width: "91vw", height: 211 }} />
            )}
          </Box>
          <Box height={150} zIndex={2} position="relative" p={3} width="70vw">
            <Row style={{ marginBottom: 16 }}>
              <Box mr={1} mt={1}>
                {info?.profilePhoto ? (
                  <Image
                    src={info?.profilePhoto}
                    fluid
                    width="40"
                    height="40"
                    style={{ borderRadius: 64 }}
                  />
                ) : (
                  <Image
                    src={`${NO_PROFILE_IMG}`}
                    fluid
                    width="40"
                    height="40"
                    style={{ borderRadius: 64 }}
                  />
                )}
              </Box>
              <Typography variant="subtitle2" className={classes.displayInfo}>
                {info?.name || "--"}
              </Typography>
            </Row>
            <Row style={{ justifyContent: "space-between" }}>
              <Typography className={classes.cardTitle}>Điện thoại</Typography>
              <Typography className={classes.cardContent}>
                {info?.phone}
              </Typography>
            </Row>
            {info?.address && (
              <Row style={{ justifyContent: "space-between", marginTop: 4 }}>
                <Typography className={classes.cardTitle}>Địa chỉ</Typography>
                <Typography className={classes.cardContent}>
                  {info?.address}
                </Typography>
              </Row>
            )}
            {info?.joinTime && (
              <Row style={{ justifyContent: "space-between", marginTop: 4 }}>
                <Typography className={classes.cardTitle}>
                  Ngày gia nhập
                </Typography>
                <Typography className={classes.cardContent}>
                  {info?.joinTime}
                </Typography>
              </Row>
            )}
          </Box>
          <Typography
            style={{ marginTop: 24, marginBottom: 8, fontWeight: 600 }}
          >
            Lịch sử kinh doanh
          </Typography>
          <Box className={classes.card} flexDirection="column">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
            >
              <Hotel />
              &nbsp;&nbsp;
              <Typography
                style={{
                  fontSize: 24,
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#007864",
                }}
              >
                {info?.bookingInfo?.hotelBookingNum}
              </Typography>
              &nbsp; Đơn phòng khách sạn
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
            >
              <AirlineTicket />
              &nbsp;&nbsp;
              <Typography
                style={{
                  fontSize: 24,
                  fontWeight: 600,
                  color: "#FF3A12",
                }}
              >
                {info?.bookingInfo?.flightBookingNum}
              </Typography>
              &nbsp; Đơn vé máy bay
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          {vipInfo?.packages?.[0]?.vipPackage?.active ? (
            <Box
              className={classes.card}
              style={{ justifyContent: "start" }}
              mt={2}
            >
              <IconGreenTick />
              <Col style={{ marginLeft: 8 }}>
                <Typography style={{ fontSize: 14 }}>
                  <b>Thành viên VIP </b>{" "}
                  <span
                    style={{
                      textTransform: "uppercase",
                      color: "#FF3366",
                      display: "flex",
                      fontSize: 12,
                      alignItems: "center",
                    }}
                  >
                    Đã được chứng nhận là đại lý du lịch
                    <Image
                      src={`${LOGO_MYTOUR}`}
                      fluid
                      alt=""
                      style={{
                        width: "90px",
                        height: "100%",
                      }}
                    />
                  </span>
                </Typography>
                <Typography variant="caption" style={{ color: "#505759" }}>
                  Thời gian: {vipInfo?.packages?.[0]?.created} -{" "}
                  {vipInfo?.packages?.[0]?.expired}
                </Typography>
              </Col>
            </Box>
          ) : (
            <Box
              className={classes.card}
              style={{ justifyContent: "start" }}
              mt={2}
            >
              <IconGreenTick className="svgFillAll" fill="#8C9497" />
              <Col style={{ marginLeft: 8 }}>
                <Typography style={{ fontSize: 14 }}>
                  Thành viên thường
                </Typography>
              </Col>
            </Box>
          )}
          <Typography style={{ fontWeight: 600, marginTop: 24 }}>
            10 đơn hàng gần nhất
          </Typography>
          <Box
            className={classes.card}
            style={{ justifyContent: "start", marginTop: 8 }}
          >
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Dịch vụ</TableCell>
                  <TableCell align="left">Thời gian đặt</TableCell>
                  <TableCell align="left">Thông tin</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortByBookingTime([
                  ...info?.bookingInfo?.lastFlightBookings.map((ele) => {
                    return { ...ele, isFlight: true };
                  }),
                  ...info?.bookingInfo?.lastHotelBookings,
                ])?.map((row) => (
                  <TableRow key={row.bookingTime}>
                    <TableCell align="left" style={{ width: 68 }}>
                      {row.isFlight ? <AirlineTicket /> : <Hotel />}
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      {row.bookingTime}
                    </TableCell>
                    <TableCell style={{ width: 100 }} align="left">
                      {row.description}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
export default BookerInfoBoxMobile;
